export default "__VITE_ASSET__C2pA1VpB__"